





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { format } from '@/utils/helper';
import { initPageParams } from '@/utils/constants';
import { IPageParam } from '@/store/types';
import * as ITypes from '@/store/brand-audit/apply/types';
import PageList from '@/components/page/Index.vue';

const Apply = namespace('brandAudit/apply');

@Component({
  components: { PageList },
})
export default class EnterpriseBrandAuthLogs extends Vue {
  @Apply.Action('queryApplyLogs') public queryLogs!: ITypes.IActions['queryApplyLogs'];
  @Apply.State('applyLogs') public logs!: ITypes.IBrandAuthLogs;

  @Prop() public visible!: boolean;

  public headers = [
    { text: '品牌编码', value: 'brandCode' },
    { text: '品牌名称', value: 'brandName' },
    { text: '申请授权时间', value: 'processingTime' },
    { text: '申请人', value: 'authUser' },
    { text: '授权结果', value: 'applyStatus' },
  ];

  public statusColor(record: ITypes.IBrandAuthLogsDto) {
    return {
      'red--text': record.applyStatus === 2 && record.status === 2,
      'blue--text': record.applyStatus === 0,
    };
  }

  public renderProcessingTime(record: ITypes.IBrandAuthLogsDto) {
    return format(record.processingTime, true);
  }

  public onPageChange(pagination: IPageParam) {
    this.queryLogs({ ...pagination });
  }

  @Watch('visible', { immediate: true })
  public watchVisible(visible: boolean) {
    if (visible) {
      this.queryLogs({ ...initPageParams });
    }
  }
}
